import "./src/styles/global.css";
import { rootWrapper } from './gatsby-wrapper'

export const wrapRootElement = rootWrapper